import PropTypes from 'prop-types';
export var propTypes = {
    defaultActiveTab: PropTypes.number,
    onTabSelect: PropTypes.func,
    children: PropTypes.node
};
//# sourceMappingURL=types.js.map